import { useState } from 'react';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import type { DatePickerProps, DateTimePickerProps } from '@mui/x-date-pickers';
import type { Dayjs } from 'dayjs';

/**
 * MUI X v6 pickers only open via the calendar icon by default; clicking the text
 * field just focuses it. These thin wrappers control the open state and also
 * open the popup when the user clicks anywhere in the field.
 */
function buildSlotProps(slotProps: any, openPicker: () => void) {
  return {
    ...slotProps,
    textField: {
      ...(slotProps?.textField || {}),
      onClick: openPicker,
    },
  };
}

export function ClickOpenDateTimePicker(props: Omit<DateTimePickerProps<Dayjs>, 'value'> & { value?: any }) {
  const [open, setOpen] = useState(false);
  return (
    <DateTimePicker
      {...props}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      slotProps={buildSlotProps(props.slotProps, () => {
        if (!props.disabled) setOpen(true);
      })}
    />
  );
}

export function ClickOpenDatePicker(props: Omit<DatePickerProps<Dayjs>, 'value'> & { value?: any }) {
  const [open, setOpen] = useState(false);
  return (
    <DatePicker
      {...props}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      slotProps={buildSlotProps(props.slotProps, () => {
        if (!props.disabled) setOpen(true);
      })}
    />
  );
}
